import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { TwSolicitudCamViewModelExtended } from '../../../types/solicitudcam-datosbasicos.types';
import { FormGroup } from '@angular/forms';
import { ComponentBase } from 'src/app/components/core/_infrastructure/classes/componentBase';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { EnumIdsTcEstadoSolicitudCam } from '../../../types/enum';
import { CodigoConfeccionItemViewModel } from 'src/app/components/_mantenimiento/registros/codigosconfeccion/codigoconfeccion.types';

@Component({
    selector: 'app-solicitud-cam-envio-form',
    templateUrl: './solicitud-cam-envio-form.component.html',
    styleUrls: ['./solicitud-cam-envio-form.component.scss'],
})
export class SolicitudCamEnvioFormComponent extends ComponentBase implements OnChanges, OnInit {
    @Input() solicitudCam: TwSolicitudCamViewModelExtended;
    @Input() almacenes: CodigoConfeccionItemViewModel[];
    @Input() almacenObligatorio = false;
    @Input() formGroup: FormGroup;

    isCollapsedCabecera = false;
    isCollapsedDatosOperador = false;
    isCollapsedDatosCicloCorto = false;

    constructor(
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificationService, exceptionHandler);
    }

    ngOnInit(): void {
        this.updateForm();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.solicitudCam?.currentValue) {
            this.solicitudCam = { ...changes.solicitudCam.currentValue };
            this.updateForm();
        }
        if (changes?.almacenes?.currentValue) {
            if (this.solicitudCam?.IdAlmacenExportacionCicloCorto !== null) {
                const found = this.almacenes?.find(almacen => almacen.Id === this.solicitudCam?.IdAlmacenExportacionCicloCorto);
                if (!found) {
                    this.formGroup.patchValue({
                        IdAlmacenExportacionCicloCorto: null,
                    });
                }
                setTimeout(() => {
                    // Lo metemos en el timeout para evitar el error ExpressionChangedAfterItHasBeenCheckedError
                    this.formGroup.controls['IdAlmacenExportacionCicloCorto'].markAsDirty();
                }, 0);
            }
        }
    }

    /**
     * This functions sets the values in the solicituCam (@Input) into the form.
     */
    private updateForm(): void {
        this.formGroup.setValue({
            Id: this.solicitudCam?.Id || null,
            IdCampania: this.solicitudCam?.IdCampania || null,
            IdPeriodoCam: this.solicitudCam?.IdPeriodoCam || null,
            IdCA: this.solicitudCam?.IdCa || null,
            IdEntidadAuditora: this.solicitudCam?.IdEntidadAuditora || null,
            IdTipoSolicitudCam: this.solicitudCam?.IdTipoSolicitudCam || null,
            Campania: this.solicitudCam?.Campania || null,
            Periodo: this.solicitudCam?.Periodo || null,
            DescripcionComunidad: this.solicitudCam?.DescripcionComunidad || null,
            EntidadAuditora: this.solicitudCam?.EntidadAuditora || null,
            TipoSolicitudCam: this.solicitudCam?.TipoSolicitudCam || null,
            IdAlmacenExportacionCicloCorto: this.solicitudCam?.IdAlmacenExportacionCicloCorto || null,
            AlmacenExportacionCicloCorto: this.solicitudCam?.AlmacenExportacionCicloCorto || '',
            // The following are read only but will be shown on screen.
            Codigo: this.solicitudCam?.Codigo || '',
            FechaSolicitud: this.solicitudCam?.FechaSolicitud ? new Date(this.solicitudCam?.FechaSolicitud) : '',
            EstadoSolicitudCam: this.solicitudCam?.EstadoSolicitudCam || '',
            OperadorRazonSocial: this.solicitudCam?.OperadorRazonSocial || '',
            OperadorNif: this.solicitudCam?.OperadorNif || '',
            OperadorTelefono: this.solicitudCam?.OperadorTelefono || '',
            // Not visible but needed
            IdEstadoSolicitudCam: this.solicitudCam?.IdEstadoSolicitudCam || null,
            FechaCreacion: this.solicitudCam?.FechaCreacion || '',
            IdUsuario: this.solicitudCam?.IdUsuario || null,
        });

        this.form = this.formGroup; // componentBase uses this.form
    }

    get mensajeEmision(): string {
        if (!this.solicitudCam) {
            return '';
        }
        let mensaje = '';
        switch (this.solicitudCam?.IdEstadoSolicitudCam) {
            case EnumIdsTcEstadoSolicitudCam.ID_BORRADOR:
                mensaje = 'Solicitud en borrador';
                break;
            case EnumIdsTcEstadoSolicitudCam.ID_PENDIENTE:
                mensaje = 'Solicitud pendiente de validación';
                break;
            case EnumIdsTcEstadoSolicitudCam.ID_DEVUELTA:
                mensaje = 'La solicitud ha sido devuelta al Operador';
                break;
            case EnumIdsTcEstadoSolicitudCam.ID_VALIDADA:
                mensaje = 'Solicitud validada';
                break;
            case EnumIdsTcEstadoSolicitudCam.ID_RECHAZADA:
                mensaje = 'Solicitud rechazada';
                break;
            case EnumIdsTcEstadoSolicitudCam.ID_ACEPTADA:
                mensaje = 'Solicitud aceptada';
                break;
        }

        return mensaje;
    }

    get visibilityCheckEnvioValue(): boolean | null {
        if (!this.solicitudCam) {
            return null;
        }
        let imagen = null;
        switch (this.solicitudCam?.IdEstadoSolicitudCam) {
            case EnumIdsTcEstadoSolicitudCam.ID_BORRADOR:
            case EnumIdsTcEstadoSolicitudCam.ID_PENDIENTE:
                imagen = null;
                break;
            case EnumIdsTcEstadoSolicitudCam.ID_DEVUELTA:
                imagen = false;
                break;
            case EnumIdsTcEstadoSolicitudCam.ID_VALIDADA:
                imagen = true;
                break;
            case EnumIdsTcEstadoSolicitudCam.ID_RECHAZADA:
                imagen = false;
                break;
            case EnumIdsTcEstadoSolicitudCam.ID_ACEPTADA:
                imagen = true;
                break;
        }

        return imagen;
    }

    get mostrarDesplegableAlmacenes(): boolean {
        if (!this.solicitudCam) {
            return false;
        }
        return (
            this.solicitudCam?.IdEstadoSolicitudCam === EnumIdsTcEstadoSolicitudCam.ID_BORRADOR ||
            this.solicitudCam?.IdEstadoSolicitudCam === EnumIdsTcEstadoSolicitudCam.ID_DEVUELTA
        );
    }
}
